import { Injectable } from '@angular/core';

export interface Toast {
    classname?: string;
    delay?: number;
    title?: string;
    message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
    toasts: Toast[] = [];

    show(toast: Toast) {
        this.toasts.push(toast);
    }

    remove(toast: Toast) {
        this.toasts = this.toasts.filter((t) => t !== toast);
    }

    clear() {
        this.toasts.splice(0, this.toasts.length);
    }
}
